import { NavLink, ThemeIcon } from '@mantine/core';
import { IconCalendarDue } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums/routes';

interface WorkAlertsLinkProps {
  navigate(route: string): void;
}

export function WorkAlertsLink({ navigate }: WorkAlertsLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: '#373A40',
        },
      }}
      label="Apontamentos"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="red.3" variant="light">
          <IconCalendarDue size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="Lista"
        onClick={() => navigate(AppRoutePaths.WORK_ALERTS)}
      />
    </NavLink>
  );
}
